
import * as Moment from "moment";
import { Component, Mixins } from "vue-property-decorator";
import { DomainRegistry } from "../../../domain";
import { ManagementTokenInformation, ManagementTokenPublishResult } from "../../../domain/system";
import { IMessages } from "../dialogs";

@Component({
})
export default class ManagementTokenCollaborativeMixin extends Mixins() {
  async executeWithManagementTokenControll(itemName: string, managementTokenGetter: (isForcibly: boolean) => Promise<ManagementTokenPublishResult>, action: () => Promise<void>): Promise<void> {
    if (!managementTokenGetter) {
      return action();
    }
    const managementTokenInfo = await this.getManagementTokenInformation(itemName, managementTokenGetter);
    if (!managementTokenInfo || !managementTokenInfo.token) {
      return;
    }
    const timetInterval = Math.max(Math.floor(managementTokenInfo.tokenLifeSpan / 3) * 1000, 10000);
    const timer = setInterval(() => this.extendManagementToken(managementTokenInfo), timetInterval);
    try {
      await action();
    } finally {
      if (timer) {
        clearInterval(timer);
      }
      this.deleteManagementToken(managementTokenInfo);
    }
  }

  private async getManagementTokenInformation(itemName: string, managementTokenGetter: (isForcibly: boolean) => Promise<ManagementTokenPublishResult>): Promise<ManagementTokenPublishResult> {
    try {
      const info = await managementTokenGetter(false);
      if (!info) {
        // nullが返却されるとしたら実装ミス
        return null;
      }
      if (info.token) {
        // 競合なし
        return info;
      }
      const isConfirmed = await this.confirmToForceEdit(itemName, info.conflictInformations);
      if (!isConfirmed) {
        // 競合あり・強制取得しない
        return info;
      }
      // 強制取得する
      return await managementTokenGetter(true);
    } catch (e) {
      this.$error(itemName, "編集の競合情報取得中にエラーが発生しました。", e);
      return null;
    }
  }

  private async confirmToForceEdit(itemName: string, conflictInfos: ManagementTokenInformation[]): Promise<boolean> {
    const messages: (string | IMessages)[] = ["指定した" + itemName + "を編集中のユーザがいます。", "強制的に編集を開始してもよろしいですか？"];
    const index = await this.$commonDialogs.confirmation.show({
      message: messages.concat(conflictInfos.map(i => this.toConflictInformationMessage(i))),
      buttons: [
        {
          kind: "danger",
          label: "編集を開始する",
        },
      ],
      cancellation: {
        isEnable: true,
        label: "中止する",
      },
    });
    return (index === 0);
  }

  private toConflictInformationMessage(editor: ManagementTokenInformation): IMessages {
    return {
      messages: [
        "編集者　　　：" + editor.userName,
        "編集端末　　：" + editor.terminalName,
        "編集開始日時：" + Moment(editor.editStartDateTime).format("YYYY/MM/DD HH:mm"),
      ],
    };
  }

  private async extendManagementToken(info: ManagementTokenPublishResult): Promise<void> {
    if (!info || !info.token) { return; }
    const repo = DomainRegistry.system.getManagementTokenRepository();
    return repo.extend(info.token);
  }

  private async deleteManagementToken(info: ManagementTokenPublishResult): Promise<void> {
    if (!info || !info.token) { return; }
    const repo = DomainRegistry.system.getManagementTokenRepository();
    return repo.delete(info.token);
  }
}
